import { WarrantyPart as WarrantyPartType } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import { useAuth } from '@hooks';
import { Box, InputAdornment, Stack, TextField } from '@mui/material';
import { t } from '@translations';
import { useWarrantyClaimContext } from '../WarrantyClaim/WarrantyClaimProvider';

type WarrantyPartsTotalPriceProps = { fields: WarrantyPartType[] };

export const WarrantyPartsTotalPrice: React.FC<WarrantyPartsTotalPriceProps> = ({
  fields,
}: WarrantyPartsTotalPriceProps) => {
  const { form } = useWarrantyClaimContext();
  const parts = form?.watch('parts');
  const partsDiscount = form?.watch('partsDiscount') || 0;
  const totalPrice =
    parts?.reduce((acc, part) => {
      const priceValue = part?.totalPrice || 0;
      return acc + priceValue;
    }, 0) || 0;

  const { isBeremaUser } = useAuth();
  const detailPriceAmount = (totalPrice * partsDiscount) / 100;
  const totalWithDetail = totalPrice - detailPriceAmount;

  return fields.length ? (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems='center'>
      <Box>{t(TextCodes.Warranty.Block.TotalPrice)}:</Box>
      <TextField
        value={totalPrice ? (+totalPrice).toFixed(2) : '0.00'}
        InputProps={{
          readOnly: true,
        }}
      />
      <Box>–</Box>
      <TextField
        type='number'
        sx={{ width: '120px' }}
        {...form.register('partsDiscount', {
          min: 0,
          max: 100,
        })}
        InputProps={{
          readOnly: !isBeremaUser,
          startAdornment: <InputAdornment position='start'>%</InputAdornment>,
          inputProps: { min: 0, max: 100 },
        }}
      />
      <Box>=</Box>
      <TextField
        sx={{ ml: 4 }}
        value={totalWithDetail ? (+totalWithDetail).toFixed(2) : '0.00'}
        InputProps={{
          readOnly: true,
        }}
      />
    </Stack>
  ) : null;
};
